import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateFilterTime, updateFilterCoach, updateFilterAmen, updateSearchResults, updateFilterReset } from '../../actions/search-actions'
import store from '../../store';

import Check from '../common/checkbox';

// import busType from '../../img/bus-type.svg';
// import clock from '../../img/departure.svg';
// import wifi from '../../img/WiFi.svg';

class Sort extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoad: true,
            showSort: 0,
            busChecked: [false, false, false, false, false, false],
            amenChecked: [],
            sorter: 1
        }
    }

    componentWillMount() {
        if (this.props.search.allAmen && this.props.search.allAmen.length > 0) {
            let amenChecked = [];
            for (let i = 0; i < this.props.search.allAmen.length; i++) {
                amenChecked.push(false);
            }
            this.setState({ amenChecked });
        }
    }

    componentDidMount() {
        window.addEventListener('click', (e) => {
            // if (this.refs.tooltip) {
                if(window.location.pathname.indexOf('checkout') === -1 && !(e.target.className === 'show-sort' || (e.target.parentNode && e.target.parentNode.className  === 'show-sort') || (e.target.parentNode && e.target.parentNode.parentNode && e.target.parentNode.parentNode.className === 'show-sort') || ((e.target.parentNode && e.target.parentNode.parentNode && e.target.parentNode.parentNode.parentNode && e.target.parentNode.parentNode.parentNode.className === 'show-sort')))) {
                    this.setState({ showSort: 0 })
                }
            // }
        })
    }

    showBusSort = () => {
        const loop = ['AC', 'Non AC', 'Seater', 'Sleeper', 'Volvo', 'Non Volvo'];
        if (this.state.showSort === 1) {
            return (
                <div className = 'show-sort'>
                    { this.props.search.coach.length > 0 ? <div className = 'reset-sort' onClick = { this.resetBusType } style = {{ color: window.color.searchBoxBgColor }}>Reset All</div> : '' }
                    {
                        loop.map((el,index) => {
                            return (
                                <Check
                                    key = { index }
                                    index = { index }
                                    value = { el }
                                    checked = { this.state.busChecked[index] }
                                    handleChange = { this.checkBusType }
                                    showValue = { el }
                                />
                            )
                        })
                    }
                </div>
            )
        }
    }

    showTimeSort = () => {
        if (this.state.showSort === 2) {
            return (
                <div className = 'show-sort'>
                    { this.props.search.time.length > 0 ? <div className = 'reset-sort' onClick = { this.resetTime } style = {{ color: window.color.searchBoxBgColor }}>Reset All</div> : '' }
                    <div className = 'time-sort'>
                        <div onClick = { () => this.checkTime(0) } className = { this.props.search.time.indexOf(0) >= 0 ? 'active' : '' }>
                            <div>12am - 6am</div>
                            <div>Early morning</div>
                        </div>
                        <div onClick = { () => this.checkTime(1) } className = { this.props.search.time.indexOf(1) >= 0 ? 'active' : '' }>
                            <div>6am - 12pm</div>
                            <div>Morning</div>
                        </div>
                        <div onClick = { () => this.checkTime(2) } className = { this.props.search.time.indexOf(2) >= 0 ? 'active' : '' }>
                            <div>12pm - 6pm</div>
                            <div>After noon</div>
                        </div>
                        <div onClick = { () => this.checkTime(3) } className = { this.props.search.time.indexOf(3) >= 0 ? 'active' : '' }>
                            <div>6pm - 12am</div>
                            <div>Night</div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    showAmenSort = () => {
        if (this.state.showSort === 3) {
            const loop = this.props.search.allAmen;
            return (
                <div className = 'show-sort'>
                    { this.props.search.amenities.length > 0 ? <div className = 'reset-sort' onClick = { this.resetAmen } style = {{ color: window.color.searchBoxBgColor }}>Reset All</div> : '' }
                    {
                        loop.map((el,index) => {
                            return (
                                <Check
                                    key = { index }
                                    index = { index }
                                    value = { el }
                                    checked = { this.state.amenChecked[index] }
                                    handleChange = { this.checkAmenType }
                                    showValue = { el }
                                />
                            )
                        })
                    }
                </div>
            )
        }
    }

    showSorter = () => {
        if (this.state.showSort === 6) {
            return (
                <div className = 'show-sort sorter'>
                    <div onClick = { () => this.sortBus(1) }>Departure time</div>
                    <div onClick = { () => this.sortBus(2) }>Price low to high</div>
                    <div onClick = { () => this.sortBus(3) }>Price high to low</div>
                </div>
            )
        }
    }

    showActiveFilters = () => {
        const prop = this.props.search;
        // const showActive = prop.amenities.length > 0 || prop.coach.length > 0 || prop.time.length > 0;
        return (
            <div style = { this.activeFilter }>
                <div style = { this.activeFilter1 }>Active Filters: </div>
                <div style = { this.activeFilter2 }>
                    { prop.coach.map(el => {
                        return <div key = { el } style = { this.activeFilterDiv } onClick = { () => this.resetSelCoach(el) }>{ el } &nbsp; &#x2715;</div>
                    }) }
                    { prop.time.map(el => {
                        return <div key = { el } style = { this.activeFilterDiv } onClick = { () => this.checkTime(el) }>{ this.getTimeFilterVal(el) } &nbsp; &#x2715;</div>
                    }) }
                    { prop.amenities.map(el => {
                        return <div key = { el } style = { this.activeFilterDiv } onClick = { () => this.resetSelAmen(el) }>{ el } &nbsp; &#x2715;</div>
                    }) }
                </div>
                <div style = { this.activeFilter3 } onClick = { () => { store.dispatch(updateFilterReset());this.resetBusType();this.resetAmen();this.resetTime(); } }>Reset All</div>
            </div>
        )
    }

    resetSelCoach = (val) => {
        let busChecked = this.state.busChecked;
        let selBusType = this.props.search.coach;
        const loop = this.props.search.staticData.coach;
        selBusType = selBusType.filter(function(a){
            return val !== a;
        })
        busChecked[loop.indexOf(val)] = false;
        this.setState({ busChecked });
        store.dispatch(updateFilterCoach(selBusType));
    }

    resetSelAmen = (val) => {
        let amenChecked = this.state.amenChecked;
        let selAmenType = this.props.search.amenities;
        const loop = this.props.search.allAmen;
        selAmenType = selAmenType.filter(function(a){
            return val !== a;
        })
        amenChecked[loop.indexOf(val)] = false;
        this.setState({ amenChecked });
        store.dispatch(updateFilterAmen(selAmenType));
    }

    getTimeFilterVal = (val) => {
        switch (val) {
            case 0:
                return '12am - 6am';
            case 1:
                return '6am - 12pm';
            case 2:
                return '12pm - 6pm';
            case 3:
                return '6pm - 12am';
            default:
                return;
        }
    }

    checkBusType = (e, index) => {
        let busChecked = this.state.busChecked;
        let selBusType = this.props.search.coach;
        busChecked[index] = e.target.checked
        if (e.target.checked) {
            selBusType.push(e.target.value);
        } else {
            selBusType = selBusType.filter(function(a){
                return e.target.value !== a;
            })
        }
        this.setState({ busChecked });
        store.dispatch(updateFilterCoach(selBusType));
    }

    resetBusType = () => {
        let busChecked = this.state.busChecked;
        for (let i = 0; i < busChecked.length; i++) {
            busChecked[i] = false;
        }
        this.setState({ busChecked });
        store.dispatch(updateFilterCoach([]));
    }

    checkAmenType = (e, index) => {
        let amenChecked = this.state.amenChecked;
        let selAmenType = this.props.search.amenities;
        amenChecked[index] = e.target.checked
        if (e.target.checked) {
            selAmenType.push(e.target.value);
        } else {
            selAmenType = selAmenType.filter(function(a){
                return e.target.value !== a;
            })
        }
        this.setState({ amenChecked });
        store.dispatch(updateFilterAmen(selAmenType));
    }

    resetAmen = () => {
        let amenChecked = this.state.amenChecked;
        for (let i = 0; i < amenChecked.length; i++) {
            amenChecked[i] = false;
        }
        this.setState({ amenChecked });
        store.dispatch(updateFilterAmen([]));
    }

    checkTime = (val) => {
        let selTime = this.props.search.time;
        if (selTime.indexOf(val) === -1) {
            selTime.push(val);
        } else {
            selTime = selTime.filter(function(a){
                return val !== a;
            })
        }
        // this.setState({ selTime });
        store.dispatch(updateFilterTime(selTime));
    }

    resetTime = () => {
        let selTime = [];
        this.setState({ selTime });
        store.dispatch(updateFilterTime([]));
    }

    sortBus = (val) => {
        let buses = this.props.search.buses;
        if (val === 1 && this.state.sorter !== 1) {
            buses = buses.sort((a,b) => {return (a.DepartureTime > b.DepartureTime) ? 1 : ((b.DepartureTime > a.DepartureTime) ? -1 : 0)});
        } else if (val === 2 && this.state.sorter !== 2) {
            buses = buses.sort((a,b) => {return (a.DiscFare > b.DiscFare) ? 1 : ((b.DiscFare > a.DiscFare) ? -1 : 0)});
        } else if (val === 3 && this.state.sorter !== 3) {
            buses = buses.sort((a,b) => {return (a.DiscFare < b.DiscFare) ? 1 : ((b.DiscFare < a.DiscFare) ? -1 : 0)});
        }
        this.setState({ sorter: val });
        store.dispatch(updateSearchResults(buses));
    }

    render() {
        const prop = this.props.search;
        const showActive = prop.amenities.length > 0 || prop.coach.length > 0 || prop.time.length > 0;
        if (prop.data && prop.data.length > 0) {
            return (
                <section className = 'sort-bar' style = { showActive ? { marginBottom: '50px' } : { marginBottom: '20px' } }>
                    <div>
                        <div onClick = { (event) => {event.stopPropagation(); this.setState({ showSort: this.state.showSort === 1 ? 0 : 1 })} }>
                            <img src = { '/img/bus-type.svg' } alt = 'bus type' />
                            BUS TYPE
                            <span className = { this.state.showSort === 1 ? 'up-arr' : 'down-arr' }></span>
                        </div>
                        { this.showBusSort() }
                    </div>
                    <div>
                        <div onClick = { (event) => {event.stopPropagation(); this.setState({ showSort: this.state.showSort === 2 ? 0 : 2 }) }}>
                            <img src = { '/img/departure.svg' } alt = 'time' />
                            TIME
                            <span className = { this.state.showSort === 2 ? 'up-arr' : 'down-arr' }></span>
                        </div>
                        { this.showTimeSort() }
                    </div>
                    {
                        prop.allAmen && prop.allAmen.length > 0 ?
                        <div>
                            <div onClick = { (event) => {event.stopPropagation(); this.setState({ showSort: this.state.showSort === 3 ? 0 : 3 }) }}>
                                <img src = { '/img/WiFI.svg' } alt = 'amenities' />
                                AMENITIES
                                <span className = { this.state.showSort === 3 ? 'up-arr' : 'down-arr' }></span>
                            </div>
                            { this.showAmenSort() }
                        </div>
                        : ''
                    }
                    <div className = 'sort-typ'>
                        <div onClick = { (event) => {event.stopPropagation(); this.setState({ showSort: this.state.showSort === 6 ? 0 : 6 }) }}>
                            SORT BY
                            <span className = { this.state.showSort === 6 ? 'up-arr' : 'down-arr' }></span>
                        </div>
                        { this.showSorter() }
                    </div>
                    { showActive ? this.showActiveFilters() : '' }
                </section>
            );
        } else {
            return <section style = {{ padding: '10px' }}></section>
        }
    }

    activeFilter = {
        position: 'absolute',
        top: 'calc(100% + 10px)',
        width: '88%',
        padding: '0',
        margin: 'auto',
        fontSize: '0.8rem',
        display: 'flex',
        alignItems: 'center',
        cursor: 'default'
    }

    activeFilter1 = {
        paddingRight: '15px'
    }

    activeFilter2 = {
        display: 'flex'
    }

    activeFilterDiv = {
        marginRight: '5px',
        background: '#fff',
        padding: '5px 10px',
        borderRadius: '3px',
        cursor: 'pointer'
    }

    activeFilter3 = {
        paddingLeft: '15px',
        color: window.color.searchBoxBgColor,
        cursor: 'pointer'
    }
}


const mapStateToProps = function(store) {
    return (store);
};

export default connect(mapStateToProps)(Sort);